import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import SearchIcon from '@mui/icons-material/Search';
import { DOCTOR_SHIFT_DROPDOWN } from '../../../../../constants/dropdown';

const TABLE_HEADER = [
  {
   header : "Doc No.",
   accessor:(row)=> row?.doc_no
  },
  {
    header: ' Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
    {
    header: 'Ipd No',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.first_name} ${row?.patient?.last_name}`}
        </span>
      );
    }
  },
  {
    header: 'Mobile No',
    accessor: (row) => row?.patient?.address?.mobile
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const ADMIT_PATIENT_TABLE_HEADER = [
  {
    header: ' Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const initialConsltantVisitingDataObj = {
  data: [],
  loading: false
};

export const ConsultantVisiting = () => {
  const doctorIDRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [consultantVisitingDataObj, setConsultantVisitingDataObj] = useState(initialConsltantVisitingDataObj);
  const [admitPatientDataObj, setAdmitPatientDataObj] = useState([]);
  const [admitPatientDialog, setAdmitPatientDialog] = useState(false);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [complaints, setComplaints] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [medicineDetailList, setmedicineDetailList] = useState([]);
  const [diagnos, setDiagnos] = useState([]);
  const [input, setInput] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [visitType, setVisitType] = useState([]);
  const [wardDropdown, setWardDropdown] = useState([]);
  const [sponsorDropdown, setSponsorDrdopdown] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [queryInput,setQueryInput] = useState('')

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }
    return age;
  };

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue, getValues } = methods;

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);

  const getVisitTypeDropdown = useCallback(async () => {
    const data = await dropdownFetch('visit-type-master');
    setVisitType(data);
  });

  const getWardDrodpown = useCallback(async () => {
    const data = await dropdownFetch('ward');
    setWardDropdown(data);
  });
  const getsponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    setSponsorDrdopdown(data);
  });

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('consultant')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }
    setDoctorDropdown(data);
  });
  useEffect(
    () => {
      getDepartmentDropdown();
      getVisitTypeDropdown();
      getWardDrodpown();
      getsponsorDropdown();
      getDoctorDropdown();
    },
    getDepartmentDropdown,
    getVisitTypeDropdown,
    getWardDrodpown,
    getsponsorDropdown,
    getDoctorDropdown
  );

  useEffect(() => {
    let total_qty = 0;
    let total_amt = 0;
    let disc_amt = 0;
    let net_amt = 0;
    let gst_amt = 0;
    detailList?.forEach((detail) => {
      total_qty += detail.quantity;
      total_amt += detail.amount;
      disc_amt += detail.disc_amt;
      gst_amt += detail.gst_amt;
      net_amt += detail.net_amt;
    });
    setValue('bill.total_qty', total_qty);
    setValue('bill.total_amt', total_amt);
    setValue('bill.disc_amt', disc_amt);
    setValue('bill.gst_amt', gst_amt);
    setValue('bill.net_amt', net_amt);
  }, [detailList, setValue]);

  const netAmtWatch = watch('bill.net_amt');
  const recAmt1Watch = watch('bill.rec_amt_1');
  const recAmt2Watch = watch('bill.rec_amt_2');
  useEffect(() => {
    const total_recpt = +recAmt1Watch + +recAmt2Watch;
    setValue('bill.total_recpt', total_recpt);
    setValue('bill.balance_amt', netAmtWatch - total_recpt);
  }, [netAmtWatch, recAmt1Watch, recAmt2Watch, setValue]);

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid',
        'complaints',
        'diagnos',
        'medicine',
        'vital'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedRegDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedRegDate);
      setValue('time',selectedRecord?.time)
      setValue('doc_no',selectedRecord?.doc_no)
      setValue('uhid', selectedRecord.uhid);
      setValue('ipd_no',selectedRecord?.ipd_no);
      setValue('visit_type',selectedRecord?.visit_type)
      setValue('doctor_shift',selectedRecord?.doctor_shift)
      setValue('doctor',selectedRecord?.doctor)
      setValue('department',selectedRecord?.department)
      setValue('no_of_visit',selectedRecord.no_of_visit)
      setValue('charge_per_visit',selectedRecord?.charge_per_visit)
      setValue('total_amount',selectedRecord?.total_amount)
      setValue('remarks',selectedRecord?.remarks)
      setValue('sponsor',selectedRecord?.patient?.sponsor)
      setValue('ward',selectedRecord?.ipdpatient?.room?.ward)
      setValue('patient_name',`${selectedRecord?.patient?.name_suffix} ${selectedRecord?.patient?.first_name} ${selectedRecord?.patient?.last_name}`)
    } else {
      reset();
    }
  }, [selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/consultant-visiting-update' : '/consultant-visiting-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValues
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Consultant Visiting Charge`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Consultant Visiting Charge`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/consultant-visiting-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Consultant Visiting', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Consultant Visiting', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/consultant-visiting-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Consultant Visiting', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Consultant Visiting', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setConsultantVisitingDataObj({ loading: true, data: [] });
    const response = await request('/consultant-visiting-list', { method: 'GET' });
    if (response.success) {
      setConsultantVisitingDataObj({ loading: false, data: response.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setConsultantVisitingDataObj({ loading: false });
    }
  };

  const handleQueryInputChange =(e)=>{
    setQueryInput(e.target.value)
  }

  useEffect(()=>{
    handleSearchConsultantVisiting()
  },[queryInput])

  const handleSearchConsultantVisiting =async()=>{
    const lowercaseInput = queryInput.toLowerCase();
    const query = {}
    query.patientName = lowercaseInput
    const response = await request('/consultant-visiting-list',{method :"GET",query:query})
    if(response.success){
      setConsultantVisitingDataObj({loading:false,data:response.data})
    }else{
      toast('Error in fetching data', { variant: 'error' });
      setConsultantVisitingDataObj({ loading: false });
    }
  }

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const handleFetchAdminPatient = async () => {
    setAdmitPatientDialog(true);
    try {
      const response = await request('/indoor-registeration-list-admit-patient', { method: 'GET' });
      if (response?.success) {
        setAdmitPatientDataObj(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(()=>{
    searchAdmitPatientData();
  },[input])

  const searchAdmitPatientData = async()=>{
   try{
    const lowercaseinput = input.toLowerCase()
    const query = {}
    query.name = lowercaseinput
    const response = await request('/indoor-registeration-list-admit-patient',{method:"GET",query:query});
      if(response.success){
        setAdmitPatientDataObj(response.data)
      }
   }catch(error){
    console.log(error)
   }
  }

  const watchSponsor = watch('sponsor');
  const watchWard = watch('ward');
  const watchVisitType = watch('visit_type');
  const watchDoctor = watch('doctor');
  const watchDepartment = watch('department');
  const doctorShift = watch('doctor_shift');

  const fetchWardCharge = async () => {
    if (!watchSponsor || !watchWard || !watchVisitType || !watchDoctor || !watchDepartment || !doctorShift) {
      console.warn('All required fields are not selected yet.');
      return;
    }

    const query = {
      sponsor: watchSponsor,
      ward: watchWard,
      visit_type: watchVisitType,
      consultant: watchDoctor,
      department: watchDepartment,
      doctor_shift: doctorShift
    };

    try {
      const data = await request('/consultant-ward-charge', {
        method: 'GET',
        query
      });
      if (data?.charge !== undefined) {
        setValue('charge_per_visit', data.charge);
      } else {
        console.warn('No charge found in response');
        setValue('charge_per_visit', 0);
      }
    } catch (error) {
      console.error('Failed to fetch ward charge:', error);
      setValue('charge_per_visit', 0);
    }
  };

  useEffect(() => {
    const allFieldsFilled =
      watchSponsor && watchWard && watchVisitType && watchDoctor && watchDepartment && doctorShift;
    if (allFieldsFilled) {
      fetchWardCharge();
    }
  }, [watchSponsor, watchWard, watchVisitType, watchDoctor, watchDepartment, doctorShift]);

  const watchNoOfVisit = watch('no_of_visit');
  const watchChargePervisit = watch('charge_per_visit');
  useEffect(() => {
    const noOfVisit = parseFloat(watchNoOfVisit) || 0;
    const chargePerVisit = parseFloat(watchChargePervisit) || 0;
    const total = noOfVisit * chargePerVisit;
    setValue('total_amount', total);
  }, [watchNoOfVisit, watchChargePervisit]);

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{ pb: 0.5, mb: 3, borderBottom: '1px solid', borderColor: 'grey.300' }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Consultant Visiting
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>

            <Grid container spacing={2}>
              <Grid item xs={6} sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doc No.</Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled
                    sx={{ flex: 0.6 }}
                    name="doc_no"
                    placeholder="Doc no."
                  />
                </Stack>
              </Grid>
              <Grid item xs={6} sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doc Date / Time</Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.4 }}
                    name="date"
                    type="date"
                  />
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.4 }}
                    name="time"
                    type="time"
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} sx={{ p: 2 }}>
                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }} />
                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }} />
              </Grid>

              <Grid item xs={12} sx={{ minHeight: '32rem' }}>
                <Stack spacing={0.5} sx={{ height: '100%' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 4,
                      height: '100%',
                      border: '1px solid rgba(0,0,0,0.27)'
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1
                        // backgroundColor: '#f5f5f5'
                      }}
                    >
                      <Typography color="primary" variant="h4" sx={{ fontWeight: 700, p: 2 }}>
                        Patient Details
                      </Typography>
                      <Grid item xs={12} sx={{ p: 1, display: 'flex', gap: 0.8, flexDirection: 'column' }}>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.28, fontWeight: 700, fontSize: '1.4rem' }}>Adm No.</Typography>
                          <TextField
                            inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                            disabled
                            sx={{ flex: 0.6 }}
                            name="ipd_no"
                            placeholder="Adm No."
                          />
                          <Button
                            disabled={!['new'].includes(currentAction)}
                            sx={{
                              flex: 0.1,
                              minWidth: '36px',
                              minHeight: '30px',
                              padding: 0,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '4px'
                            }}
                            variant="contained"
                            onClick={handleFetchAdminPatient}
                          >
                            <SearchIcon fontSize="medium" />
                          </Button>
                        </Stack>

                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>UHID No.</Typography>
                          <TextField
                            inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                            disabled
                            sx={{ flex: 0.8 }}
                            name="uhid"
                            placeholder="UHID"
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                          <TextField
                            inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                            disabled
                            sx={{ flex: 0.8 }}
                            name="patient_name"
                            placeholder="Patient Name"
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                          <SelectTag
                            disabled
                            formControlSX={{ flex: 0.8 }}
                            name="sponsor"
                            placeholder="Select Sponsor"
                            menus={sponsorDropdown.map((data) => ({ ...data, name: data.name }))}
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ward</Typography>
                          <SelectTag
                            menus={wardDropdown.map((data) => ({ ...data, name: data.name }))}
                            disabled
                            formControlSX={{ flex: 0.8 }}
                            name="ward"
                            placeholder="Select Ward"
                          />
                        </Stack>
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        flex: 1
                        //  backgroundColor: '#f5f5f5'
                      }}
                    >
                      <Typography color="primary" variant="h4" sx={{ fontWeight: 700, p: 2 }}>
                        Visit Details
                      </Typography>
                      <Grid item xs={12} sx={{ p: 1, display: 'flex', gap: 0.8, flexDirection: 'column' }}>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Visit Type</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{ flex: 0.8 }}
                            name="visit_type"
                            menus={visitType.map((data) => ({ ...data, name: data.VISIT_TYPE }))}
                            placeholder="Visit Type"
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor Shift</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{ flex: 0.8 }}
                            name="doctor_shift"
                            menus={DOCTOR_SHIFT_DROPDOWN}
                            placeholder="Select Doctor Shift"
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor Name</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{ flex: 0.8 }}
                            name="doctor"
                            placeholder="Select Doctor"
                            menus={doctorDropdown.map((data) => ({ ...data, name: data.name }))}
                            onChange={({ target: { row } }) => {
                              setValue('department', row.qualification_details.department);
                            }}
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                          <SelectTag
                            menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{ flex: 0.8 }}
                            name="department"
                            placeholder="Select Department"
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>No Of Visit</Typography>
                          <TextField
                            inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                            disabled={!['new', 'edit'].includes(currentAction)}
                            sx={{ flex: 0.8 }}
                            name="no_of_visit"
                            placeholder="No of visit"
                            type="number"
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center">
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>
                            Charge Per Visit
                          </Typography>
                          <TextField
                            inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                            disabled
                            sx={{ flex: 0.8 }}
                            name="charge_per_visit"
                            placeholder="Charge Per Visit"
                            type="number"
                          />
                        </Stack>
                      </Grid>
                    </Box>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Amount</Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled
                    sx={{ flex: 0.6 }}
                    name="total_amount"
                    placeholder="Total Amount"
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.6 }}
                    name="remarks"
                    placeholder="Remarks"
                  />
                </Stack>
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Consultant Visiting Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={queryInput}
            onChange={handleQueryInputChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={consultantVisitingDataObj?.data || []}
          loading={consultantVisitingDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>

      <Dialog
        open={admitPatientDialog}
        onClose={() => setAdmitPatientDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Admit Patients
          </Typography>
          <IconButton onClick={() => setAdmitPatientDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={ADMIT_PATIENT_TABLE_HEADER}
          data={admitPatientDataObj || []}
          loading={admitPatientDataObj.loading}
          onRowClick={(row) => {
            setValue('patient_name', row?.patient?.name);
            setValue('ipd_no', row?.ipd_no);
            setValue('uhid', row?.uhid);
            setValue('sponsor', row?.patient?.sponsor);
            setValue('ward', row?.consultant_detail?.room?.ward?._id);
            setAdmitPatientDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
